import { CommonRegistry } from '../components/components';
import {
  CommonFilteredComponentSystem,
  FilteredComponentSystemUpdateEntityArgs,
} from './SystemBase';

export class MovementSystem extends CommonFilteredComponentSystem {
  public componentClasses: (keyof CommonRegistry)[] = ['Transform', 'Velocity'];
  protected simulationBound = true;

  updateEntity({
    world,
    entityId,
    deltaTime,
  }: FilteredComponentSystemUpdateEntityArgs<CommonRegistry>): void {
    const vel = world.getComponent(entityId, 'Velocity')!;
    const transform = world.getComponent(entityId, 'Transform')!;

    /**
     * CRITICAL: Skip server-side physics integration for player-controlled entities.
     * With client-authoritative movement, the server must not 'advance' the player's
     * position independently, as this causes discrepancies.
     *
     * Exception: Server-driven external forces (e.g. Knockback) still need
     * to be integrated authoritatively on the server.
     */
    if (
      (!this.services.isClient &&
        world.hasComponent(entityId, 'PlayerControlled') &&
        !world.hasComponent(entityId, 'Knockback')) ||
      world.hasComponent(entityId, 'FastMovement')
    ) {
      return;
    }

    const newX = transform.x + vel.dx * deltaTime;

    const newY = transform.y + vel.dy * deltaTime;

    if (newX !== transform.x || newY !== transform.y) {
      this.updateComponent(entityId, transform, { x: newX, y: newY });
    }
  }
}
